import { render } from "./AccountBindPrompt.vue?vue&type=template&id=3944aa9a&scoped=true"
import script from "./AccountBindPrompt.vue?vue&type=script&lang=js"
export * from "./AccountBindPrompt.vue?vue&type=script&lang=js"

import "./AccountBindPrompt.vue?vue&type=style&index=0&id=3944aa9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3944aa9a"]])

export default __exports__